import React from "react";
import * as Styled from "./styles";
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  //Modal,
  TextField,
  Typography,
} from "@mui/material";

//import toast from "react-hot-toast";
//import { Odontograma } from "components/Odontograma";
import { useMaintenance } from "shared/providers/Maintenance";
import toast from "react-hot-toast";

const PlanningInvisible: React.FC = () => {
  const {
    setStep,

    setAllObservationsPlanning,
    allObservationsPlanning,
    attachmentExchange,
    setChangeAttachmentExchange,
    changeAttachmentExchange,
    setAttachmentExchange,
    setRealizeIPRExchange,
    realizeIPRExchange,
    /*setOdontogramaAttachmentExchange,
    odontogramaAttachmentExchange,*/
    patientObj,
    controlContainment,
    setControlContainment,
    setHihgPlanning,
    highPlanning,
  } = useMaintenance();

  /* const [modalOdontoAttachment, setModalOdontoAttachment] =
    React.useState<boolean>(false);*/

  const next = () => {
    if (
      patientObj.qtd_contencao === 7 &&
      patientObj.proc_name === "Controle de Contenção"
    ) {
      if (!highPlanning) {
        toast.error("Selecione se recebeu alta");
        return false;
      }
      setStep(3);
      return false;
    }

    if (patientObj.proc_name === "Controle de Contenção") {
      if (!controlContainment) {
        toast.error("Selecione o Controle de Contenção");
        return false;
      }
      setStep(3);
      return false;
    }

    setStep(3);
  };

  return (
    <Styled.Box>
      {patientObj.qtd_contencao === 7 &&
      patientObj.proc_name === "Controle de Contenção" ? (
        <Styled.BoxIndication>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={highPlanning}
                  onClick={() => {
                    setHihgPlanning(!highPlanning);
                  }}
                />
              }
              label="Alta"
            />
          </FormGroup>
        </Styled.BoxIndication>
      ) : patientObj.proc_name === "Controle de Contenção" ? (
        <Styled.BoxIndication>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={controlContainment}
                  onClick={() => {
                    setControlContainment(!controlContainment);
                  }}
                />
              }
              label="Controle de Contenção"
            />
          </FormGroup>
        </Styled.BoxIndication>
      ) : (
        <>
          <Styled.BoxIndication>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={attachmentExchange}
                    onClick={() => {
                      setAttachmentExchange(!attachmentExchange);
                      setChangeAttachmentExchange([]);
                    }}
                  />
                }
                label="Troca de Attachment"
              />
            </FormGroup>

            {attachmentExchange && (
              <>
                <Styled.BoxButtons>
                  <Button
                    variant={
                      changeAttachmentExchange.includes("SUP")
                        ? "contained"
                        : "outlined"
                    }
                    onClick={() => {
                      if (changeAttachmentExchange.includes("SUP")) {
                        setChangeAttachmentExchange(
                          changeAttachmentExchange.filter(
                            (type) => type !== "SUP"
                          )
                        );
                      } else {
                        setChangeAttachmentExchange([
                          ...changeAttachmentExchange,
                          "SUP",
                        ]);
                      }
                    }}
                  >
                    Superior
                  </Button>
                  <Button
                    variant={
                      changeAttachmentExchange.includes("INF")
                        ? "contained"
                        : "outlined"
                    }
                    onClick={() => {
                      if (changeAttachmentExchange.includes("INF")) {
                        setChangeAttachmentExchange(
                          changeAttachmentExchange.filter(
                            (type) => type !== "INF"
                          )
                        );
                      } else {
                        setChangeAttachmentExchange([
                          ...changeAttachmentExchange,
                          "INF",
                        ]);
                      }
                    }}
                  >
                    Inferior
                  </Button>
                </Styled.BoxButtons>
              </>
            )}
            {/*changeAttachmentExchange.length > 0 && (
          <>
            <Button
              sx={{ margin: "20px 0" }}
              onClick={() => setModalOdontoAttachment(true)}
            >
              Abrir Odontograma
            </Button>

            <Modal
              open={modalOdontoAttachment}
              onClose={() => setModalOdontoAttachment(false)}
            >
              <Odontograma
                onClose={() => setModalOdontoAttachment(false)}
                selected={odontogramaAttachmentExchange}
                setSelected={setOdontogramaAttachmentExchange}
                subtitle="Troca de Attachment"
              />
            </Modal>
          </>
        )*/}
          </Styled.BoxIndication>

          <Styled.BoxIndication>
            <Typography
              variant="h5"
              sx={{ marginTop: "5px", marginBottom: "10px" }}
            >
              Necessidade de IPR ?
            </Typography>
            <Styled.BoxButtons style={{ marginBottom: "10px" }}>
              <Button
                variant={
                  realizeIPRExchange === "YES" ? "contained" : "outlined"
                }
                onClick={() => {
                  setRealizeIPRExchange("YES");
                }}
              >
                Sim
              </Button>
              <Button
                variant={realizeIPRExchange === "NO" ? "contained" : "outlined"}
                onClick={() => {
                  setRealizeIPRExchange("NO");
                }}
              >
                Não
              </Button>
            </Styled.BoxButtons>
          </Styled.BoxIndication>
          <Styled.BoxIndication>
            <TextField
              label="Observações gerais"
              fullWidth
              margin="normal"
              value={allObservationsPlanning}
              onChange={(e) => setAllObservationsPlanning(e.target.value)}
              multiline
              minRows={4}
            />
          </Styled.BoxIndication>
        </>
      )}

      <Styled.BtnFixed>
        <Button fullWidth onClick={() => setStep(1)} variant="outlined">
          Voltar
        </Button>
        <Button fullWidth onClick={next}>
          Continuar
        </Button>
      </Styled.BtnFixed>
    </Styled.Box>
  );
};

export { PlanningInvisible };
